export default ({ children }) => {
    return(
        <main className="container">
            { children }
        </main>
    )
}